import { SanityDocument } from "next-sanity";

/* eslint-disable @typescript-eslint/no-explicit-any */
export function splitArrayIntoThree(arr: SanityDocument[]) {
  const total = arr.length;
  const size = Math.ceil(total / 3);

  const first = arr.slice(0, size);
  const second = arr.slice(size, size * 2);
  const third = arr.slice(size * 2);

  return [first, second, third];
}
